export const UUID_KEY = 'chat-wf-uuid';

export const CHAT_LAST_MESSAGE = 'chat-wf-last-message-id';
export const CHAT_LAST_MESSAGE_READ = 'chat-wf-last-message-read-id';

export const POPUP_WAS_OPENED = 'support-chat-wf-popup-close';
